import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import {
  ButtonsContainerComponent,
  IIntegrationDialogData,
} from '@principle-theorem/ng-shared';
import {
  type IStripeIntegrationData,
  StripeIntegrationStorage,
} from '@principle-theorem/stripe-integration';
import { type Observable } from 'rxjs';
import { StripeConnectButtonComponent } from '../stripe-connect-button/stripe-connect-button.component';
import { StripeFunctions } from '../stripe-functions.service';
import { MatToolbar } from '@angular/material/toolbar';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'pt-manage-stripe-integration',
  templateUrl: './manage-stripe-integration.component.html',
  styleUrls: ['./manage-stripe-integration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButton,
    MatToolbar,
    MatDialogModule,
    ButtonsContainerComponent,
    MatProgressSpinner,
    StripeConnectButtonComponent,
  ],
})
export class ManageStripeIntegrationComponent {
  private _data =
    inject<IIntegrationDialogData<IStripeIntegrationData>>(MAT_DIALOG_DATA);
  private _stripeStorage: StripeIntegrationStorage =
    new StripeIntegrationStorage();
  hasStripeIntegration$: Observable<boolean>;
  loading = false;

  constructor(private _stripeFunctions: StripeFunctions) {
    this.hasStripeIntegration$ = this._stripeStorage.has$(
      this._data.integrationsCol
    );
  }

  async openStripeConnect(): Promise<void> {
    this.loading = true;
    const stripeConnectUrl = await this._stripeFunctions.connectRedirect(
      this._data.orgUid
    );
    window.open(stripeConnectUrl, '_blank');
    this.loading = false;
  }
}
